module.exports = __webpack_public_path__ + "img/Ia.5967305a.png";